// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: "https://stage.getubetter.com/",
  assetUrl: "https://stage.getubetter.com",
  server: "stage",
  nhsSettingsUrl: "https://settings.aos.signin.nhs.uk",
  transKey: 'e7d9f3a2-1c5b-4e8f-9a6d-3b0c7f251e84',
};

/* NHS Settings URLs

Production: https://settings.login.nhs.uk

Sandpit: https://settings.sandpit.signin.nhs.uk

Integration: https://settings.aos.signin.nhs.uk
*/

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
